import { MentoringProgramMatchingType } from 'redux/schemas/models/mentoring-programs';
import { CustomCommunicationMessageType } from 'redux/schemas/models/mentorship-program-custom-communications';
import { config } from '@config/pendo.config.json';

const getMatchAnnouncementSentOnTranslation = (
  matchingType: MentoringProgramMatchingType,
  aliases,
  translationBase
) => {
  if (matchingType === MentoringProgramMatchingType.AUTOMATED_MATCHING) {
    return translationBase.MATCH_ANNOUNCEMENT.SENT_ON.ASSIGNED();
  }
  if (matchingType === MentoringProgramMatchingType.PARTICIPANT_DRIVEN) {
    return translationBase.MATCH_ANNOUNCEMENT.SENT_ON.PARTICIPANT_DRIVEN(
      aliases
    );
  }
  return '';
};

export const messageTypeMap = (
  t,
  matchingType?: MentoringProgramMatchingType,
  aliases?
) => {
  const translationBase = t.MENTORING_PROGRAMS.COMMUNICATIONS.MESSAGE_TYPES;
  const dataQATag =
    config.pendo.athena.mentorshipProgram.communications.editCommunicationModal
      .delivery.messageType;

  return {
    [CustomCommunicationMessageType.WELCOME_MESSAGE]: {
      title: translationBase.WELCOME_MESSAGE.TITLE(),
      sentOn: translationBase.WELCOME_MESSAGE.SENT_ON(),
      dataQa: dataQATag.welcomeMessageOption,
    },
    ...(matchingType !== MentoringProgramMatchingType.PARTICIPANT_DRIVEN && {
      [CustomCommunicationMessageType.PROFILE_COMPLETION_REMINDER]: {
        title: translationBase.PROFILE_COMPLETION_REMINDER.TITLE(),
        sentOn: translationBase.PROFILE_COMPLETION_REMINDER.SENT_ON(),
        dataQa: dataQATag.profileCompletionReminderOption,
      },
    }),
    [CustomCommunicationMessageType.MATCH_ANNOUNCEMENT]: {
      title: translationBase.MATCH_ANNOUNCEMENT.TITLE(),
      sentOn:
        matchingType && aliases
          ? getMatchAnnouncementSentOnTranslation(
              matchingType,
              aliases,
              translationBase
            )
          : '',
      dataQa: dataQATag.matchAnnouncementOption,
    },
  };
};
